<div class="cd-tabs-radio-button">
  @for (item of options; track item) {
  <div (click)="onChange(item.value)" class="item" [ngClass]="item.value === selectedValue ? 'selected' : ''">
    <div>
      <span class="cds-body1-demibold">
        {{ item.label }}
      </span>
    </div>
  </div>
  }
</div>
